var alertCookie = (function ($, Cookies, options) {

    'use strict';

    /* Public scope and variables */
    var self = {};
    self.settings = {};

    /* Private functions */
    function init() {
        bootstrap();
    }

    function bootstrap() {
        bindUI();
    }

    function bindUI() {
        var alert_close_button = $('.alert-close-button');
        var alert = $('.alert');

        if (readCookie()) {
            closeAlert(alert);
        }

        bindEvent(alert_close_button, alert)
    }

    function bindEvent(alert_close_button, alert) {
        $(alert_close_button).click(function () {
            closeAlert(alert);
            applyCookie();
        });
    }

    function closeAlert(alert) {
        $(alert).hide();
    }

    function applyCookie() {
        Cookies.set('sc_closed_alert', true);
    }

    function readCookie() {
        return Cookies.get('sc_closed_alert');
    }

    init();

    return self;

}(jQuery, Cookies, {}));